(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-fbq-event-tracker', actionFunc);

    function actionFunc($q, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {

                try {
                    var type = lodash.get(options, 'type', null);
                    var fb_pixel_id = lodash.get(options, 'fb_pixel_id', null);
                    var value = lodash.get(options, 'value', {});
                    if (!!type) {
                        if (typeof fbq == typeof undefined) {
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                                n.queue=[];t=b.createElement(e);t.async=!0;
                                t.src=v;s=b.getElementsByTagName(e)[0];
                                s.parentNode.insertBefore(t,s)}(window, document,'script',
                                'https://connect.facebook.net/en_US/fbevents.js');

                        }
                        if (!!fb_pixel_id) {
                            fbq('init', fb_pixel_id);
                            fbq('track', 'PageView');
                        }
                        fbq('track', type, value);
                    }
                    return true;
                } catch (err) {
                    return false;
                }


            }
        };
    }
})();